// extracted by mini-css-extract-plugin
export var editInput = "_fz-0";
export var editInputCompact = "_fz-2";
export var editInputLarge = "_fz-1";
export var editInputSmall = "_fz-3";